// extracted by mini-css-extract-plugin
export default {"wrapper":"LetrusLoader_wrapper__PZs5P","bar1":"LetrusLoader_bar1__m9Urw","shimmer":"LetrusLoader_shimmer__ImPsc","likeAnimation":"LetrusLoader_likeAnimation__otkBw"};